import React from 'react';
import { CollapsibleContainer2 as CollapsibleContainer } from '@components/common/CollapsibleContainer/CollapsibleContainer';

interface Question {
  a: string;
  q: string;
}

export default function SrpSeoFAQ({ questions }: { questions: Question[] }) {
  return (
    <div>
      <h2 className="font-rp-basetica text-lg text-solar-primary my-spacing-md">
        Frequently Asked Questions
      </h2>

      <div
        className="mt-spacing-sm grid grid-cols-1 gap-x-spacing-2xl desktop:grid-cols-2 font-rp-basetica"
        data-testid="faq-grid"
      >
        {questions.map((question) => (
          <div className="py-spacing-md" key={question.q}>
            <CollapsibleContainer
              title={<p className="text-14 text-solar-primary">{question.q}</p>}
              noBorder
              initiallyExpanded={false}
              iconSize={16}
            >
              <div
                className="font-rp-basetica text-solar-secondary py-spacing-md text-14"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: question.a }}
              />
            </CollapsibleContainer>
          </div>
        ))}
      </div>
    </div>
  );
}
